(function () {
  function parseData(root) {
    const script = root.querySelector('[data-shade-catalog-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch {
      return null;
    }
  }

  function formatMoney(cents, currencyCode) {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(value / 100);
    } catch {
      return '$' + (value / 100).toFixed(2);
    }
  }

  function clear(element) {
    while (element && element.firstChild) element.removeChild(element.firstChild);
  }

  function findShade(data, id) {
    return (data.shades || []).find((shade) => String(shade.id) === String(id));
  }

  function stockLabel(shade) {
    if (!shade.available) return 'Sold out';
    if (String(shade.inventoryPolicy || '').toUpperCase() === 'CONTINUE') return 'Available';
    const quantity = Math.max(0, Number(shade.inventoryQuantity) || 0);
    return `${quantity} in stock`;
  }

  function dispatchCartUpdate(cart, payload, shade) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'shade-gallery',
        data: {
          itemCount: cart?.item_count || 0,
          source: 'shade-gallery',
          variantId: shade.variantId,
          sections: payload?.sections || {},
        },
      },
    }));
  }

  function init(root) {
    const data = parseData(root);
    if (!data || !Array.isArray(data.shades)) return;

    const cards = Array.from(root.querySelectorAll('[data-shade-card]'));
    const filters = Array.from(root.querySelectorAll('[data-finish-filter]'));
    const count = root.querySelector('[data-shade-count]');
    const dialog = root.querySelector('[data-shade-dialog]');
    const dialogImage = root.querySelector('[data-dialog-image]');
    const dialogSwatch = root.querySelector('[data-dialog-swatch]');
    const dialogThumbs = root.querySelector('[data-dialog-thumbs]');
    const dialogFinish = root.querySelector('[data-dialog-finish]');
    const dialogName = root.querySelector('[data-dialog-name]');
    const dialogPrice = root.querySelector('[data-dialog-price]');
    const dialogDescription = root.querySelector('[data-dialog-description]');
    const dialogFacts = root.querySelector('[data-dialog-facts]');
    const dialogAdd = root.querySelector('[data-dialog-add]');
    const dialogProductLink = root.querySelector('[data-dialog-product-link]');
    const dialogStatus = root.querySelector('[data-dialog-status]');
    let activeShade = null;
    let activeImageIndex = 0;
    let activeFilter = 'ALL';
    let adding = false;

    function renderCount(visibleCount) {
      if (!count) return;
      count.textContent = `${visibleCount} shade${visibleCount === 1 ? '' : 's'}`;
    }

    function applyFilter(finishKey) {
      activeFilter = finishKey;
      let visible = 0;
      cards.forEach((card) => {
        const show = finishKey === 'ALL' || card.dataset.finish === finishKey;
        card.hidden = !show;
        if (show) visible += 1;
      });
      filters.forEach((filter) => {
        filter.setAttribute('aria-pressed', filter.dataset.finishFilter === finishKey ? 'true' : 'false');
      });
      renderCount(visible);
    }

    function imagesFor(shade) {
      return Array.isArray(shade.images) ? shade.images.filter((image) => image && image.src) : [];
    }

    function renderImage(shade) {
      const images = imagesFor(shade);
      const image = images[activeImageIndex] || images[0];
      clear(dialogThumbs);

      if (image) {
        dialogImage.hidden = false;
        dialogSwatch.hidden = true;
        dialogSwatch.style.removeProperty('background-color');
        dialogImage.src = image.src;
        dialogImage.alt = image.alt || shade.name;
      } else {
        dialogImage.hidden = true;
        dialogImage.removeAttribute('src');
        dialogSwatch.hidden = false;
        dialogSwatch.style.backgroundColor = shade.fallbackColor || '#D8D0C8';
      }

      images.forEach((entry, index) => {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'shade-catalog__thumb';
        thumb.setAttribute('aria-current', index === activeImageIndex ? 'true' : 'false');
        thumb.setAttribute('aria-label', `View ${shade.name} image ${index + 1}`);
        const thumbnailImage = document.createElement('img');
        thumbnailImage.src = entry.src;
        thumbnailImage.alt = '';
        thumb.appendChild(thumbnailImage);
        thumb.addEventListener('click', () => {
          activeImageIndex = index;
          renderImage(shade);
        });
        dialogThumbs.appendChild(thumb);
      });
    }

    function renderFacts(shade) {
      clear(dialogFacts);
      [
        ['Finish', shade.finishName || shade.finishKey],
      ].forEach(([label, value]) => {
        const item = document.createElement('div');
        item.className = 'shade-catalog__fact';
        const term = document.createElement('dt');
        term.textContent = label;
        const description = document.createElement('dd');
        description.textContent = value || '';
        item.appendChild(term);
        item.appendChild(description);
        dialogFacts.appendChild(item);
      });
    }

    function renderActions(shade) {
      dialogAdd.textContent = adding ? 'Adding...' : shade.available ? 'Add shade to bag' : 'Sold out';
      dialogAdd.disabled = adding || !shade.available;
      dialogProductLink.href = shade.productUrl || '#';
      dialogProductLink.hidden = !shade.productUrl;
    }

    function openShade(shade) {
      activeShade = shade;
      activeImageIndex = 0;
      dialogStatus.textContent = '';
      dialogFinish.textContent = shade.finishName || shade.finishKey || '';
      dialogName.textContent = shade.name || '';
      dialogPrice.textContent = formatMoney(shade.price, data.currencyCode);
      dialogDescription.textContent = shade.description || '';
      renderImage(shade);
      renderFacts(shade);
      renderActions(shade);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    async function addShade() {
      if (!activeShade || !activeShade.available || adding) return;
      adding = true;
      dialogStatus.textContent = '';
      renderActions(activeShade);

      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((item) => item.dataset.sectionId)
          .filter(Boolean);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: activeShade.variantId, quantity: 1 }],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || 'Unable to add this shade.');
        }
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((cartResponse) => cartResponse.json());
        dispatchCartUpdate(cart, payload, activeShade);
        dialogStatus.textContent = `${activeShade.name} added to bag.`;
      } catch (error) {
        dialogStatus.textContent = error instanceof Error ? error.message : 'Unable to add this shade.';
      } finally {
        adding = false;
        renderActions(activeShade);
      }
    }

    filters.forEach((filter) => {
      filter.addEventListener('click', () => applyFilter(filter.dataset.finishFilter || 'ALL'));
    });

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        const shade = findShade(data, card.dataset.shadeId);
        if (!shade) return;
        event.preventDefault();
        openShade(shade);
      });
    });

    root.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialogAdd?.addEventListener('click', addShade);

    applyFilter(activeFilter);
  }

  document.querySelectorAll('[data-shade-catalog]').forEach(init);
})();
